import React, { Component } from 'react';
import { setupImageEditor } from './image-editor-logic.js';
import './image-studio-opener-loader.js';

class ImageEditor extends Component {
  constructor(props) {
    super(props);
    this.state = {
      mediaImageStudio: void 0,
      mediaImageStudioEvents: void 0
    };
    const {
      componentData: { src },
      helpers,
      pubsub,
      imageEditorWixSettings,
      onImageEditorOpen
    } = this.props;
    const onSave = (file) => {
      pubsub == null ? void 0 : pubsub.getBlockHandler("handleFilesSelected")([file]);
      onClose();
    };
    const onClose = () => {
      var _a;
      (_a = helpers == null ? void 0 : helpers.closeModal) == null ? void 0 : _a.call(helpers);
    };
    onImageEditorOpen && onImageEditorOpen();
    this.id = "imageEditor";
    setupImageEditor(imageEditorWixSettings, this.id, src.file_name, onSave, onClose);
  }
  render() {
    return /* @__PURE__ */ React.createElement("div", { id: this.id, nofocus: "true" });
  }
}

export { ImageEditor as default };
//# sourceMappingURL=image-editor.js.map
